import { useEffect, useRef } from 'react';
import { useCrossTabCount } from 'hooks/useCrossTabCount';
import { useFeatureFlag } from 'hooks/useFeatureFlags';
import { EBroadcastChannel, EFeatureFlag } from 'constants/enums';

const REFRESH_COUNT_THRESHOLD = 5;

/**
 * Hook that tracks store-refresh tab opens across browser tabs and
 * prompts the user when the threshold is reached.
 *
 * @example
 * useStoreRefreshCount();
 */
export const useStoreRefreshCount = (): void => {
  const isEnabled = useFeatureFlag(EFeatureFlag.POPUP_STORE_REFRESH_ENABLED);
  const { count, increment, reset } = useCrossTabCount({
    channelName: EBroadcastChannel.STORE_REFRESH_CHANNEL_NAME,
    storageKey: EBroadcastChannel.STORE_REFRESH_STORAGE_KEY,
  });

  const hasIncrementedRef = useRef(false);

  useEffect((): void => {
    if (!isEnabled) return;

    if (!hasIncrementedRef.current) {
      hasIncrementedRef.current = true;
      increment();
    }

    if (count >= REFRESH_COUNT_THRESHOLD) {
      confirm(`BroadcastChannel works! Tab refresh count reached ${count}.`);
      reset();
    }
  }, [isEnabled, count]);
};
